import { QueryService } from '../services'

export default (rut) => {
  return new Promise((resolve) => {
    QueryService.getTransfenciasEstadoResumen(rut)
      .then(response => resolve(response.data))
      .catch(err => console.log(err))
  })
}
